// TODO: Fix eslint issues the next time this file is edited.
/* eslint-disable @next/next/link-passhref */
import React from 'react';
import NextLink from 'next/link';
import { Block, Flex, Spacer, Text, Theme } from 'vcc-ui';
import blogPosts from '../../blog-manifest.json';
import Layout from '../../layouts/blog';

const BlogArchive = () => {
  return (
    <Layout title="All Posts" isIndexPage>
      <Theme>
        {(theme) => (
          <Flex extend={{ flexDirection: 'column' }}>
            <Spacer size={{ default: 0, [theme.breakpoints.fromL]: 4 }} />
            <Text as="h1" variant="cook">
              All Posts
            </Text>
            <Spacer size={4} />
            <Block
              as="ol"
              extend={{
                listStyle: 'none',
                margin: 0,
                padding: 0,
              }}
            >
              {blogPosts.map(({ title, date, path }) => (
                <Block
                  key={path}
                  extend={{
                    borderBottom: `1px solid ${theme.color.ornament.border}`,
                  }}
                >
                  <NextLink href={path}>
                    <Flex
                      as="a"
                      href={path}
                      extend={{
                        flexDirection: 'column',
                        textDecoration: 'none',
                        color: theme.color.foreground.primary,
                        '&:hover h2': {
                          textDecoration: 'underline',
                        },
                      }}
                    >
                      <Spacer size={3} />
                      <Text as="h2" variant="hillary">
                        {title}
                      </Text>
                      <Spacer size={1} />
                      <Text
                        variant="bates"
                        extend={{ color: theme.color.foreground.secondary }}
                      >
                        Published {date}
                      </Text>
                      <Spacer size={3} />
                    </Flex>
                  </NextLink>
                </Block>
              ))}
            </Block>
          </Flex>
        )}
      </Theme>
    </Layout>
  );
};

export default BlogArchive;
